import React from "react";
import './dashboard.css';
import logo1 from "../assets/images/logo1.png";
import logo2 from "../assets/images/logo2.png";
import logo3 from "../assets/images/logo3.png";
import logo4 from "../assets/images/logo4.png";
import Simplechart from "./chart/Simplechart";
import Chart from "./chart/Chart";
import Areachart from "./chart/Areachart";
import Piechart from "./chart/Piechart";

const Dashboard=()=>{

return(
         <div className="dash-container">
            <div className="dash-top">
                <div className="dash-top-items">
                    <div className="icon">
                       <img src={logo1} alt="logo"/>
                    </div>
                    <div className="values">
                        <span>Profit</span>
                        <span>2500k</span>
                    </div>
                </div>

                <div className="dash-top-items">
                    <div className="icon">
                        <img src={logo2} alt ="logo"/>
                    </div>
                    <div className="values">
                        <span>Likes</span>
                        <span>1235</span>
                    </div>
                </div>

                <div className="dash-top-items">
                    <div className="icon">
                    <img src={logo3} alt ="logo"/>
                    </div>
                    <div className="values">
                        <span>Sales</span>
                        <span>550</span>
                    </div>
                </div>

                <div className="dash-top-items">
                    <div className="icon">
                    <img src={logo4} alt ="logo"/>
                    </div>
                    <div className="values">
                        <span>New members</span>
                        <span>255</span>
                    </div>
                </div>
            </div>


            <div className="dash-content">
                <div className="chart1">
                     <Simplechart/>
                </div>
                <div className="chart2">
                    <Chart/>
                </div>
                <div className="chart3">
                    <Areachart/>
                </div>
                <div className="chart4">
                    <Piechart/>
                </div>
            </div>
         </div>

)
}
export default Dashboard;

